import { render, staticRenderFns } from "./StoreOrderDetail.vue?vue&type=template&id=24712906&scoped=true"
import script from "./StoreOrderDetail.vue?vue&type=script&lang=js"
export * from "./StoreOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./StoreOrderDetail.vue?vue&type=style&index=0&id=24712906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24712906",
  null
  
)

export default component.exports